import { ITimeoutService } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { CancelSubscriptionType, PackageThumbnail } from '../../common/services/package/package.model';
import { CancelSubscriptionAction } from './cancel-subscription-dialog.action';
import { PaycellService } from '../services/paycell.service';
import { MasterpassService } from '../services/masterpass.service';
import GoogleAnalyticsService from '../../common/services/analytics/google-analytics.service';
import UtilService from '../../common/services/util.service';

/* @ngInject */
export default class CancelSubscriptionDialogController implements ActionHandler {
  private dialogElement;

  protected packet: PackageThumbnail;
  protected onDeleteSuccess: (type: CancelSubscriptionType) => void;
  private msisdnTr: string;
  private masterCardName: string;

  private warning: string;

  constructor(
    private $element,
    private $sce,
    private $translate,
    private actionDispatcher: ActionDispatcherService,
    private googleAnalytics: GoogleAnalyticsService,
    private $timeout: ITimeoutService,
    private paycellService: PaycellService,
    private masterpassService: MasterpassService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#card-delete-dialog').remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof CancelSubscriptionAction) {
      if (!!action.packet.nextRenewalDate) {
        this.$translate('dialog.cancelSubscription.warning', action.packet.nextRenewalDate).then(value => {
          this.warning = this.$sce.trustAsHtml(value);
        });
      } else {
        this.$translate('dialog.cancelSubscription.warningNoDate').then(value => {
          this.warning = this.$sce.trustAsHtml(value);
        });
      }
      this.packet = action.packet;
      this.onDeleteSuccess = action.onDeleteSuccess;
      this.msisdnTr = action.msisdnTr;
      this.masterCardName = action.masterCardName;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
  }

  public onDelete() {
    if (this.masterCardName && this.msisdnTr) {
      this.masterpassService.recurringOrderDelete({
        accountChangedEventName: '',
        accountKey: this.msisdnTr,
        authenticationMethod: '',
        cardAlias: this.masterCardName,
        productId: this.packet.sardisOfferId,
        requestReferenceNumber: UtilService.generateRandomNumber(999999999999).toString()
      }).catch(() => null);
    }

    this.paycellService
      .deletePacket(this.packet)
      .then((response:CancelSubscriptionType) => {
        this.close();
        this.onDeleteSuccess(response);
      })
      .catch((error) => {
        console.log('error', error);
        this.googleAnalytics.sendCancelPackage('Failure',this.packet, error);
        this.close()});
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/cancel-subscription-dialog/cancel-subscription-dialog.controller.ts